import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { EntryMethod } from 'src//common/enumerations/entry-method';
import { convertCurrency } from 'src//common/helpers/currency-helper';
import { submitPayment } from 'src//tendering/business-logic/handle-tender-payment';
import BaseButton from 'src/common/components/base-button';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { styles } from './tender-group-view-styles';

const SuggestedAmountButtons: React.FC<SuggestedAmountButtonsProps> = ({
  suggestedAmounts,
  disabled,
  currencyCode,
  updateCurrentAmount,
  selectedTender,
}): JSX.Element => {
  const classes = styles();
  return (
    <Grid item data-testid='suggested-amount-buttons'>
      {(suggestedAmounts || []).map(amount => (
        <BaseButton
          key={amount}
          buttonType='white'
          data-testid='suggested-amount-button'
          className={classes.tenderButton}
          disabled={disabled}
          onClick={() => {
            updateCurrentAmount({
              target: {
                name: 'current-amount',
                value: amount.toFixed(2),
              },
            });
            submitPayment(amount, EntryMethod.Tapped, selectedTender);
          }}
        >
          <Typography className={classes.labelText}>
            {convertCurrency(amount, currencyCode)}
          </Typography>
        </BaseButton>
      ))}
    </Grid>
  );
};

export interface SuggestedAmountButtonsProps {
  suggestedAmounts?: number[];
  currencyCode?: string;
  disabled: boolean;
  updateCurrentAmount: (e) => void;
  selectedTender: ITender;
}

export default SuggestedAmountButtons;
